.vc-text-base {
    font-family: var(--font-primary);
    line-height: normal;

    /* Discord puts an insane default margin on p tags, so reset that here */
    margin: 0;
}

.vc-text-defaultColor {
    color: var(--text-default);
}